import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiClient } from "./api";

export type VoiceMode = "off" | "sandwich" | "e2e";

export const voiceModeResponseSchema = z.object({
  voice_mode: z.enum(["off", "sandwich", "e2e"]),
});

export async function fetchVoiceMode(): Promise<VoiceMode> {
  const { voice_mode } = await apiClient.get("/chat/voice-mode", voiceModeResponseSchema);
  return voice_mode;
}

export const voiceModeQueryKey = ["voice-mode"] as const;

/** Reads the global `voice_mode` (the authenticated, non-admin read path). It
 * rarely changes, so it is cached for the session. */
export function useVoiceMode() {
  return useQuery({
    queryKey: voiceModeQueryKey,
    queryFn: fetchVoiceMode,
    staleTime: 5 * 60_000,
  });
}

/** The voice-training control is shown only for an enabled mode. It stays
 * hidden when `off` AND while the mode is still loading, so an `off` deployment
 * never flashes the control. */
export function isVoiceControlVisible(voiceMode: VoiceMode | undefined): boolean {
  return voiceMode === "sandwich" || voiceMode === "e2e";
}
